<template>
  <div
    class="regulatory-contract"
    v-loading="isLoading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeMethod="changeMethod"
    >
    </SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="false"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column type="seq" title="序号" width="50" align="center"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <template v-if="item.field === 'contractStatus'">{{
              translateStatus(row.contractStatus)
            }}</template>
            <template v-else-if="item.field === 'receiveMoneyMethod'">{{
              translatePayMethod(row.receiveMoneyMethod)
            }}</template>
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!-- 撤回弹框 -->
    <WithdrawalDialog
      ref="withdrawalDialogRef"
      :withdrawalType="withdrawalType"
      @refreshTable="resetBtnClick"
    />
    <!-- 审批弹框 -->
    <ApprovalDialog ref="approvalDialogRef" @refreshTable="resetBtnClick" />
    <!-- 关闭合同提示 -->
    <CloseContractDialog ref="closeContractDialogRef" @refreshTable="closeContractHandler" />
  </div>
</template>

<script>
  import { searchFormColumns, baseColumnListDefault } from './index.js';
  import tableBtnMixin from './tableBtnMixin';
  import superviseContractApi from '@/api/park/superviseContract';
  import WithdrawalDialog from './components/WithdrawalDialog/index.vue';
  import ApprovalDialog from './components/ApprovalDialog/index.vue';
  import CloseContractDialog from './../SuperviseContractDetail/components/CloseContractDialog/index.vue';
  import superviseContractMixin from './../superviseContractMixin.js';
  import API from '@/api/park/contract';
  import BASE_API from '@/api/dataBase.js';
  export default {
    mixins: [tableBtnMixin, superviseContractMixin],
    name: 'SuperviseContractList',
    data() {
      return {
        tableData: [],
        multipleSelection: [], // 表格被选中的行数据
        checkRowKeys: [],
        departList: [],
        menuButtonList: [], // 表格功能按钮
        query: {
          pledgeeNo: '',
          pledgorNo: '',
          goodsType: '',
          goodsTypeName: '',
          // goodsCategory: '',
          storageCompanyNo: '',
          storageCompanyName: '',
          contractNo: '',
          parkCompanyNo: '',
          parkDepartmentNo: '',
          contractNature: '',
          contractStatus: '',
          contractValidFrom: '',
          contractValidUntil: '',
          paperContractNo: '',
        },
        contractStatusList: [], // 合同状态
        contractNatureList: [], // 合同性质
        contractPayMethodList: [], // 收款方式
        columnList: baseColumnListDefault,
        loading: false,
        selectionList: [],
        isLoading: true,
        changeRowData: null,
        isCreate: true,
        isPaid: true,
      };
    },
    computed: {
      //表单字段
      searchColumns() {
        return searchFormColumns(this);
      },
    },
    mounted() {
      this.contractStatusList = this.dictListMap.SuperviseContractStatusType;
      this.contractNatureList = this.dictListMap.SuperviseContractNature;
      this.contractPayMethodList = this.dictListMap.SuperviseContractPayMethod;
      this.getButtonList();
      this.getTableData();
    },
    methods: {
      handleSelectionChange(row) {
        console.log(row, '选择行');
        this.selectionList = row;
      },
      // 获取当前登录人所在的部门
      getDepartmentList(code) {
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: code,
        };
        this.$axios.post(BASE_API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            this.departList = (res.data.data.personDepartmentInfo || []).map((v) => {
              return {
                label: v.personDepartmentName,
                value: v.personDepartmentCode,
              };
            });
          } else {
            this.departList = [];
          }
        });
      },
      // 根据合同号获取结算单列表
      async getSettlementList() {
        console.log('huoqujiesuanliebiao');
        const rowData = this.selectionList[0];
        if (rowData.contractNo) {
          const { data } = await this.$axios.post(API.QUERY_SETTLEMENT_LIST, {
            contractNo: rowData.contractNo,
          });
          if (!data.data.length) {
            this.isCreate = false;
          } else {
            data.data.map((item) => {
              if (item.settlementIssueStatus != '01' || item.receiveStatus != '01') {
                this.isPaid = false;
              }
            });
          }
          console.log('data获取结算单列表', data);
        }
      },
      closeContractHandler() {
        // 判断当前是否为变更主体的时候
        // if (this.changeRowData) {
        //   // 路由直接跳转
        //   const path = {
        //     path: `/park/superviseContract/detail`,
        //     name: 'detail',
        //     meta: {
        //       keepAlive: false,
        //       title: '监管合同维护',
        //     },
        //     query: {
        //       status: 'change',
        //       id: this.changeRowData.id,
        //     },
        //   };
        //   this.changeRowData = null;
        //   this.$store.dispatch('tagsView/addTabView', path).then(() => {
        //     this.$nextTick(() => {
        //       this.$router.push(path);
        //     });
        //   });
        // }
        this.resetBtnClick();
      },
      // 搜索
      searchBtnClick() {
        console.log(this.query, '搜索');
        if (!this.isCheckCurrentCompanyBelongParkCompany()) {
          this.$message.error('当前公司不支持该操作');
          return;
        }
        this.getTableData();
      },
      // 重置
      resetBtnClick() {
        if (!this.isCheckCurrentCompanyBelongParkCompany()) {
          this.$message.error('当前公司不支持该操作');
          return;
        }
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.idList = [];
        this.getTableData();
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          // this.getColumnInfo();
        });
      },
      //获取当前列
      // getColumnInfo() {
      //   this.getColumnList(baseColumnListDefault).then((res) => {
      //     this.columnList = res;
      //   });
      // },
      //双击事件
      dblclickEvent({ row }) {
        if (!this.isCheckCurrentCompanyBelongParkCompany()) {
          this.$message.error('当前公司不支持该操作');
          return;
        }
        const { contractStatus, contractNo, id } = row;
        console.log(row, '双击行', contractStatus, contractNo, id);
        const name = 'detail';
        const path = {
          path: `/park/superviseContract/${name}`,
          name: name,
          meta: {
            keepAlive: false,
            title: '监管合同维护',
          },
          query: {
            status: 'detail',
            contractNo: contractNo ? contractNo : '',
            id,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 表单中事件
      changeMethod({ val, prop }) {
        console.log(val, prop, '触发');
        const selectRowData = (val && val[0]) || {};
        if (prop == 'pledgeeNo') {
          this.query.pledgeeNo = selectRowData.partnerCode;
        } else if (prop == 'pledgorNo') {
          this.query.pledgorNo = selectRowData.partnerCode;
        } else if (prop == 'goodsType') {
          this.query.goodsType = selectRowData.productChName;
          this.query.goodsTypeName = selectRowData.productChName;
        } else if (prop == 'goodsCategory') {
          this.query.goodsCategory = selectRowData.parentProductNo;
        } else if (prop == 'storageCompanyNo') {
          this.query.storageCompanyNo = selectRowData.storageCompanyCode;
        } else if (prop == 'storageNo') {
          this.query.storageNo = selectRowData.storageCode;
        } else if (prop == 'parkCompanyNo') {
          this.query.parkDepartmentNo = null;
          this.getDepartmentList(val);
        }
      },
      // 翻译表格状态 contractStatusList
      translateStatus(status) {
        return this.contractStatusList.find((item) => item.value == status)?.label;
      },
      // 翻译收款方式
      translatePayMethod(status) {
        return this.contractPayMethodList.find((item) => item.value == status)?.label;
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
      async getTableData() {
        console.log('获取表单数据1');
        if (!this.isCheckCurrentCompanyBelongParkCompany()) {
          this.isLoading = false;
          this.$message.error('当前公司不支持该操作');
          return;
        }
        this.isLoading = true;
        const postData = {
          ...this.query,
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
        };
        const {
          data: { code, data },
        } = await this.$axios.post(superviseContractApi.GET_PAGE_DATA, postData);
        this.isLoading = false;
        if (code == 0) {
          this.$refs.siruiTable.setPageTotal(data.total);
          this.tableData = Object.freeze(data.records);
        } else {
          this.$message.error('查询表格数据失败');
        }
      },
    },
    components: {
      WithdrawalDialog,
      ApprovalDialog,
      CloseContractDialog,
    },
  };
</script>
